@use '../../styling/colors.scss' as *;

.ItemMenuButton {
  display: flex;
  padding: 4px;
  align-items: flex-start;
  gap: 10px;
  border: 0;
  background: none;
  cursor: pointer;
  border-radius: 3px;
  color: $theme-filter-icon-color;

  path {
    fill: $theme-filter-icon-color;
  }

  &:focus,
  &:active {
    outline: none;
    background: $theme-color-secondary-button-active;

    path {
      fill: $color-primary-purple;
    }
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }
}

.CustomButton {
  cursor: pointer;
  display: inline-flex;
  background: $theme-color-background;
  border-radius: 6px;
  border: 1px solid $theme-color-secondary-button-border;
  height: 32px;
  padding: 7px 16px;

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  &:disabled {
    cursor: default;
    color: $theme-color-readonly-field-text;
    opacity: 0.5;
  }

  .IconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    gap: 8px;

    path {
      fill: $theme-filter-icon-color;
    }
  }
}
